export default function flattenRelativeImports(rawCode) {
  return rawCode.replace(/from (['"])\..*\//g, "from $1./");
}